import React,{useEffect} from "react";
import { useNavigate } from "react-router";
import clsx from "clsx";
import PropTypes from "prop-types";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  colors,
  makeStyles,
  Link
} from "@material-ui/core";
import { Icon } from '@iconify/react';
import { useSelector, useDispatch } from "react-redux";
import { fetchAllDetails } from "src/views/overDueOrders/_overDue_Action";
const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
  },
  avatar: {
    backgroundColor: colors.green[600],
    height: 56,
    width: 56,
  },
  differenceIcon: {
    color: colors.green[900],
  },
  differenceValue: {
    color: colors.green[900],
    marginRight: theme.spacing(1),
  },
}));

const OverDueOrder = ({ className, ...rest }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const navigate = useNavigate();

  let allFetchData = useSelector((state) => state.overDueOrder._allDetails.totalOverDueOrders) || [];

  useEffect(() => {
    dispatch(fetchAllDetails());
  },[])
  
  return (
    <Card className={clsx(classes.root, className)} {...rest}>
      <CardContent>
        <Grid container justifyContent="space-between" spacing={3}>
          <Grid item>
            <Typography color="textSecondary" gutterBottom variant="h6">
              PENDING OVER DUE ORDERS
            </Typography>
            <Typography color="textPrimary" variant="h3">
              {allFetchData}
            </Typography>
          </Grid>
          <Grid item>
            <Avatar className={classes.avatar}>
            <Icon icon="ic:outline-pending-actions" style={{fontSize:'30px'}} rotate={2} hFlip={true} vFlip={true} />
            </Avatar>
          </Grid>
        </Grid>
       <Box mt={2} display="flex" alignItems="center" justifyContent="space-between">
         we have total {allFetchData} pending over due orders
         <Link style={{ cursor : "pointer" }} onClick={() => navigate("/app/over_due", { replace: true })} color="primary">
         View all
         </Link>
        </Box>
      </CardContent>
    </Card>
  );
};

OverDueOrder.propTypes = {
  className: PropTypes.string,
};

export default OverDueOrder;
